import React, { useState, useEffect, useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import logger from '../../utils/logger';
import APIWrapper from '../../utils/graphqlwrapper';
import AppContext from '../../context';
import TabPanel from '../TabPanel';
import { logReactErrBoundaryError } from '../../utils';
import FallbackOnError from '../FallbackOnError';
import CodeGroupings from '../../views/CodeGroupings';
import BulkUpload from '../../views/BulkUpload';
import ClientAudiences from '../../views/ClientAudiences';

const COMMITTEE_CLIENTS = ['dscc', 'dccc', 'dga'];

function Codes() {
  const [tab, setTab] = useState(0);
  const [autogroupingClient, setAutogroupingClient] = useState(false);
  const param = useParams();
  const { client } = param;
  const { setShouldLogOut } = useContext(AppContext);

  useEffect(() => {
    setAutogroupingClient(false);
    setTab(0);

    if (!client) {
      logger.error('Client ID is missing in the URL parameters.');
      return;
    }

    const fetchClientData = async () => {
      const result = await APIWrapper.queryApi({ query: 'getClient' }, setShouldLogOut, {
        client_id: client,
      });
      return result;
    };
    fetchClientData()
      .then((results) => {
        // determine if the client is autogrouping and set in state
        const data = results?.data?.[0]?.[0];
        if (data && data.is_autogrouping && !COMMITTEE_CLIENTS.includes(client)) {
          setAutogroupingClient(true);
        }
      })
      .catch((err) => logger.error(err));
  }, [client, setShouldLogOut]);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <ErrorBoundary
      FallbackComponent={FallbackOnError}
      onError={logReactErrBoundaryError}
      onReset={(details) => {
        logger.info('details', details);
        // Reset the state of your app so the error doesn't happen again
      }}
    >
      <div>
        <header className="App-header">
          <h2>Codes Management</h2>
        </header>
        <Box sx={{ width: '100%' }}>
          <>
            {' '}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tab} onChange={handleChange}>
                <Tab label="Group Codes" />
                <Tab label="Bulk Upload" />
                {autogroupingClient && (
                  <Tab label="Client Audiences" />
                )}
              </Tabs>
            </Box>
            <>
              <TabPanel label="Group Codes" value={tab} index={0}>
                <CodeGroupings client={client} />
              </TabPanel>
              <TabPanel label="Bulk Upload" value={tab} index={1}>
                <BulkUpload client={client} />
              </TabPanel>
              {autogroupingClient && (
                <TabPanel label="Client Audiences" value={tab} index={2}>
                  <ClientAudiences client={client} />
                </TabPanel>
              )}
            </>
          </>
        </Box>
      </div>
    </ErrorBoundary>
  );
}

export default Codes;
